import script from "./ChargeField.vue?vue&type=script&setup=true&lang=js"
export * from "./ChargeField.vue?vue&type=script&setup=true&lang=js"

import "./ChargeField.vue?vue&type=style&index=0&id=67958664&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67958664"]])

export default __exports__